import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { InvoiceView } from "./invoicecard/InvoiceView";

import {
  getEndcustomerPaidByInvoiceID,
  getEndCustomerPrintedByInvoiceID,
  getEndcustomerAccountsByInvoiceID,
  getUsers,
} from "API/swesum";
import InvoiceWorkflows from "Components/Invoice/Workflows/InvoiceWorkflows";
import { useInvoices } from "Context/Invoices";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function Invoice() {
  const { getInvoiceById } = useInvoices();
  const { invoiceID } = useParams();
  const [selectedLogs, setSelectedLogs] = useState(false);
  const [showWarningLog, setShowWarningLog] = useState(false);
  const [loading, setLoading] = useState(true);

  const [invoice, setInvoice] = useState(null);
  const [clientAccounts, setClientAccounts] = useState(null);
  const [endcustomerAccounts, setEndcustomerAccounts] = useState(null);
  const [payedInvoices, setPayedInvoices] = useState(null);
  const [printedInvoices, setPrintedInvoices] = useState(null);
  const [logs, setLogs] = useState(null);
  const [users, setUsers] = useState(null);

  const { openError } = usePopupNotificationContext();

  useEffect(() => {
    asyncInit();
  }, [invoiceID]);

  const asyncInit = async () => {
    try {
      setLoading(true);
      setInvoice(await getInvoiceById(invoiceID));
      setUsers(await getUsers());
      setPayedInvoices(await getEndcustomerPaidByInvoiceID(invoiceID));
      setPrintedInvoices(await getEndCustomerPrintedByInvoiceID(invoiceID));
    } catch (err) {
      openError("Något gick fel vid hämtning av faktura.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (invoice) {
      setLogs(invoice?.Logs);
      setClientAccounts(invoice?.ClientAccounts);
      setEndcustomerAccounts(invoice?.EndCustomerAccounts);
    }
  }, [invoice]);

  const asyncFetchEndCustomerPrintedByInvoiceId = async () => {
    setPrintedInvoices(await getEndCustomerPrintedByInvoiceID(invoiceID));
  };

  const fetchEndcustomerAccounts = async () => {
    const res = await getEndcustomerAccountsByInvoiceID(invoiceID);
    setEndcustomerAccounts([...res].sort((a, b) => a.Id - b.Id));
  };

  useEffect(() => {
    if (logs) {
      for (const log of logs) {
        if (log.UserAction === "Skapat logg manuellt") {
          setShowWarningLog(true);
          break;
        }
      }
    }
  }, [logs]);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 1 }}
          >
            <Grid
              item
              xs={12}
              md={12}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <InvoiceView
                invoice={invoice}
                setInvoice={setInvoice}
                printedInvoices={printedInvoices}
                fetchPrintedInvoices={asyncFetchEndCustomerPrintedByInvoiceId}
                latestManualLog={logs?.find(
                  (log) => log.UserAction === "Skapat logg manuellt"
                )}
                loading={loading}
                setSelectedLogs={setSelectedLogs}
                refreshInvoice={asyncInit}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <InvoiceWorkflows
                invoiceID={invoice?.Id}
                clientAccounts={clientAccounts}
                endcustomerAccounts={endcustomerAccounts}
                fetchAccounts={fetchEndcustomerAccounts}
                payedInvoices={payedInvoices}
                printedInvoices={printedInvoices}
                fetchPrintedInvoices={asyncFetchEndCustomerPrintedByInvoiceId}
                logs={logs}
                users={users}
                selectedLogs={selectedLogs}
                resetSelectedLogs={() => setSelectedLogs(false)}
                loading={loading}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
